"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  release: {
    title: '放单/换单查询',
    blNo: '提单号',
    containerNo: '箱号',
    result: '查询结果',
    tips_1: '温馨提示：',
    tips_2: '（1） 此处仅显示海运单已签发或提单已电放且仅显示装港首次操作的状态，如实际操作有变化请以代理通知为准！',
    tips_3: '（2） 此处换单状态、换单时间信息仅供参考，实际操作时请以与相关港口确认为准！',
    releaseBlInfo: '放单信息',
    releaseStatus: '放单状态',
    releaseDate: '放单时间',
    changeBlInfo: '换单信息',
    changeStatus: '换单状态',
    changeDate: '换单时间'
  }
};